import { ReactNode } from "react";
import { UserType } from "../../../models/enums/userType.enum";
import ProfileContactTab from "./ProfileContactTab";
import UserAccountSecurityTab from "./security/UserAccountSecurityTab";

/**
 * Tab configuration for general user profile contact information.
 */
interface TabsData {
  label: string;
  content: ReactNode;
}

/**
 * Tab configuration for changing the user's password.
 */
const profileContact: TabsData = {
  label: "forms.tabs.userAccount",
  content: <ProfileContactTab />,
};

/**
 * Tabs shown for general users.
 */
const changePassword: TabsData = {
  label: "forms.tabs.security",
  content: <UserAccountSecurityTab />,
};

/**
 * Tabs shown for speaker users.
 */
const tabsItemsUser: TabsData[] = [profileContact];

/**
 * Tabs shown for speaker users.
 */
const tabsItemsSpeaker: TabsData[] = [profileContact];

/**
 * Tabs shown for participant users (includes password change).
 */
const tabsItemsParticipant: TabsData[] = [profileContact, changePassword];

/**
 * Returns the list of tabs based on the user's role.
 *
 * @param userType - The type of user (Admin, Speaker, Participant, etc.)
 * @returns An array of tab configurations appropriate for the given user type.
 */
export function getTabsByRole(userType?: UserType): TabsData[] {
  switch (userType) {
    case UserType.Undefined:
      return tabsItemsUser;
    case UserType.Admin:
      return tabsItemsUser;
    case UserType.Speaker:
      return tabsItemsSpeaker;
    case UserType.Participant:
      return tabsItemsParticipant;
    case UserType.Employee:
    case UserType.Apprentice:
      return tabsItemsUser;
    default:
      return tabsItemsUser;
  }
}
